import { ArbeitszeitBeginnendeSettingDao } from './arbeitszeit-beginnende-setting-dao.model';
import { BaseSetting } from './base-setting.model';
import { KeyValuePair } from './key-value-pair.model';

export class ArbeitszeitSettingDao extends BaseSetting {
  constructor(settings: KeyValuePair[]) {
    super(settings);

    //Urp-Pausenvorgabe
    this.arbeitszeit = this.getValue<ArbeitszeitBeginnendeSettingDao>(
      'arbeitszeitVorgabe',
      new ArbeitszeitBeginnendeSettingDao('08:00', '17:00'),
    );
  }

  arbeitszeit: ArbeitszeitBeginnendeSettingDao;

  public override getSettings(): KeyValuePair[] {
    return [
      new KeyValuePair(
        'arbeitszeitVorgabe',
        JSON.stringify(
          JSON.stringify({
            //Double-stringify => aufgrund von bisheriger Datenspeicherung
            beginn: this.arbeitszeit.beginn,
            ende: this.arbeitszeit.ende,
          }),
        ),
      ),
    ];
  }
}
